module.exports = __webpack_public_path__ + "static/assets/15124c8f39b68da5419c0104b3d35027.png";